import script from "./historyEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./historyEdit.vue?vue&type=script&setup=true&lang=ts"

import "./historyEdit.vue?vue&type=style&index=0&id=26bfe8cd&scoped=true&lang=scss"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26bfe8cd"]])

export default __exports__